export default {"src":"/_next/static/media/plus.10bf14c4.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};